import CreateChatGroupModal from "./CreateChatGroupModal";

export default CreateChatGroupModal;